import React, { FC, useContext } from 'react';
import { Context } from '@front10/helpers/dist/Context';
import FareItemOriginDestination, {
  FareItemOriginDestinationProps
} from '../../../items/_commons/atoms/FareItemOriginDestination';
import Box from '../../../elements/Box';
import Button from '../../../elements/Button';
import Icon from '../../../elements/Icon';
import { BoxProps } from '../../../elements/Box/Box';
import FareItemCard from '../../../items/FareItemCard';

export interface CheckAvailabilityCardProps {
  originDestinationSettings?: FareItemOriginDestinationProps;
  fareItemSettings?: $TSFixMe;
  closeButtonSettings?: $TSFixMe;
  closeBtnIconSettings?: $TSFixMe;
  containerSettings?: BoxProps;
  showCloseButton?: boolean;
  onClickCloseBtn?: () => void;
}

const CheckAvailabilityCard: FC<CheckAvailabilityCardProps> = (
  props: CheckAvailabilityCardProps
) => {
  const {
    originDestinationSettings = {},
    fareItemSettings = {},
    containerSettings = {},
    closeButtonSettings = {},
    showCloseButton,
    onClickCloseBtn,
    closeBtnIconSettings = {}
  } = props;

  const { translate } = useContext(Context);

  const baseCloseBtnStyle = {
    'cmp-styles': {
      position: 'absolute',
      top: '0px',
      'z-Index': '1',
      right: '0px',
      'background-color': 'transparent !important',
      border: 'unset',
      margin: '1px'
    }
  };

  return (
    <Box className="check-availability-container" {...containerSettings}>
      {(showCloseButton || showCloseButton === undefined) && (
        <Button
          {...baseCloseBtnStyle}
          ariaLabel={translate('cmp-interactive-map-fare-card-close', 'Close')}
          color="primary"
          type="button"
          {...closeButtonSettings}
          onClick={() => {
            onClickCloseBtn?.();
          }}
        >
          <Icon icon={'close'} {...closeBtnIconSettings} />
        </Button>
      )}
      <FareItemOriginDestination {...originDestinationSettings} />
      <FareItemCard {...fareItemSettings} tabIndex={0} tabIndexCallToAction={true} />
    </Box>
  );
};

export default CheckAvailabilityCard;
